import qrCode from './QR/eth.png'

const address = '0x7571FfD6D59A275FEda3a7AA5e6503Fa22E91CF8'

export default { qrCode, address }